"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataGridSpinnerGlass = exports.CustomLabelsDataGridContainer = exports.ExplorerStyledDataGridContainer = void 0;
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
const LayoutStyles_1 = require("./LayoutStyles");
// styles from vizportalclient, src/app/spaces/Explorer/ExplorerStyles.ts
// and overrides from reactDataGrid.styl
exports.ExplorerStyledDataGridContainer = (0, vizportalclient_common_components_1.divWithStyle)('dataGridContainer', {
    flex: 1,
    color: widgets_1.TabStyles.Typography.Color.Primary,
    fontSize: '14px',
    $nest: {
        '.tb-react-dg-hrow': {
            border: 'none',
        },
        '.tb-react-dg-hcell-resizable': {
            border: 'none',
        },
        '.tb-react-dg-hcol': {
            border: 'none !important',
        },
        '.tb-react-dg-body': {
            borderTop: `1px solid ${widgets_1.TabStyles.Colors.F3}`,
        },
        '.tb-react-dg-bcell': {
            pointerEvents: 'none',
            paddingLeft: 0,
            paddingRight: 0,
            $nest: {
                '&:focus': {
                    outline: 'none',
                },
                '> div': {
                    pointerEvents: 'all',
                },
            },
        },
    },
});
exports.CustomLabelsDataGridContainer = (0, vizportalclient_common_components_1.divWithStyle)('dataGridContainer', {
    flex: 1,
    color: widgets_1.TabStyles.Typography.Color.Primary,
    $nest: {
        '.tb-react-dg-hrow': {
            border: 'none',
        },
        '.tb-react-dg-hcell-resizable': {
            border: 'none',
        },
        '.tb-react-dg-bcell': {
            paddingLeft: 0,
            paddingRight: 0,
            $nest: {
                '&:focus': {
                    outline: 'none',
                },
                '> div': {
                    pointerEvents: 'all',
                },
            },
        },
    },
});
exports.DataGridSpinnerGlass = (0, vizportalclient_common_components_1.divWithStyle)('DataGridSpinnerGlass', Object.assign(Object.assign({}, LayoutStyles_1.absolutePositionFillStyle), { background: 'rgba(255,255,255,.6)' }));
//# sourceMappingURL=DataGridStyles.js.map